import * as React from "react";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  align-items: center;
  margin: 8px 0;
`;
const Icon = styled.div`
  margin: 0 4px 0 0;
`;
const H2 = styled.h2`
  flex-grow: 1;
  font-family: Inter, sans-serif;
  font-size: 1rem;
  line-height: 1.25rem;
  font-weight: 600;
  text-align: left;
  letter-spacing: -0.017rem;
  margin: 0;
`;

const SectionTitle = ({ children, renderIcon }) => {
  return (
    <Container>
      {renderIcon && <Icon>{renderIcon()}</Icon>}
      <H2>{children}</H2>
    </Container>
  );
};

export default SectionTitle;
